<template>
  <div class="container">

      <div class="words">
        <WordleWord></WordleWord>
      </div>

    <WordleKeyboard/>
  </div>
</template>
<script>
import WordleWord from "@/components/WordleWord.vue"
import WordleKeyboard from "@/components/WordleKeyboard.vue"

export default {
  components:{
    WordleWord,
    WordleKeyboard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-exact: #6aaa64;
$color-exist: #c9b458;
$color-used: #3a3a3c;

.container{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
}
</style>
